var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ShadowlessElement, WithDisposable } from '@blocksuite/lit';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
export class LiteralElement extends WithDisposable(ShadowlessElement) {
}
__decorate([
    property({ attribute: false })
], LiteralElement.prototype, "type", void 0);
__decorate([
    property({ attribute: false })
], LiteralElement.prototype, "value", void 0);
__decorate([
    property({ attribute: false })
], LiteralElement.prototype, "onChange", void 0);
let BooleanLiteral = class BooleanLiteral extends LiteralElement {
    render() {
        return this.value ? 'True' : 'False';
    }
};
BooleanLiteral = __decorate([
    customElement('data-view-literal-boolean-view')
], BooleanLiteral);
export { BooleanLiteral };
let NumberLiteral = class NumberLiteral extends LiteralElement {
    render() {
        return (this.value?.toString() ?? html `<span class="dv-color-2">Empty</span>`);
    }
};
NumberLiteral.styles = css `
    data-view-literal-number-view {
      display: block;
      max-width: 100px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  `;
NumberLiteral = __decorate([
    customElement('data-view-literal-number-view')
], NumberLiteral);
export { NumberLiteral };
let StringLiteral = class StringLiteral extends LiteralElement {
    render() {
        return (this.value?.toString() ?? html `<span class="dv-color-2">Empty</span>`);
    }
};
StringLiteral.styles = css `
    data-view-literal-string-view {
      display: block;
      max-width: 100px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  `;
StringLiteral = __decorate([
    customElement('data-view-literal-string-view')
], StringLiteral);
export { StringLiteral };
//# sourceMappingURL=literal-element.js.map